import { Box, Text, styled } from '@ltvco/refresh-lib/theme';

import { OVERLAY_HEADER_HEIGHT } from '../components';

export const NavContainer = styled(Box)(({ theme }) => ({
  display: 'none',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  width: 255,
  minWidth: 255,
  flexShrink: 0,
  alignSelf: 'flex-start',
  position: 'sticky',
  top: OVERLAY_HEADER_HEIGHT + 8,
  maxHeight: `calc(100vh - ${OVERLAY_HEADER_HEIGHT + 8 + 16}px)`,
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  padding: theme.spacing(1.5),
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

export const NavOverviewLink = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  display: 'block',
  lineHeight: '16px',
  '&:hover': { color: theme.palette.primary.main },
}));

export const NavGroupLabel = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  fontWeight: 700,
  color: isActive ? theme.palette.primary.main : theme.palette.text.primary,
  cursor: 'pointer',
  display: 'block',
  lineHeight: '16px',
  '&:hover': { color: theme.palette.primary.main },
}));

export const NavChildItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(1.5),
  alignItems: 'center',
  paddingLeft: '11px',
  cursor: 'pointer',
  '&:hover .nav-child-text': { color: theme.palette.primary.main },
}));

export const NavChildIndicator = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  width: 2,
  height: 28,
  flexShrink: 0,
  backgroundColor: isActive
    ? theme.palette.primary.main
    : theme.palette.divider,
}));

export const NavChildLabel = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  color: isActive ? theme.palette.primary.main : theme.palette.text.secondary,
  fontWeight: isActive ? 600 : 400,
  lineHeight: '16px',
}));

export const NavLeafItem = styled(Text, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ theme, isActive }) => ({
  color: isActive ? theme.palette.primary.main : theme.palette.text.secondary,
  fontWeight: isActive ? 600 : 400,
  cursor: 'pointer',
  display: 'block',
  lineHeight: '16px',
  '&:hover': { color: theme.palette.primary.main },
}));
